<div class="image-text-box">
    <div class="image-text-box__container-image">
        <img class="image-text-box__image"
             :src="require('../../assets/' + imagePath)"
            alt="Image"
        />
    </div>

    <div class="image-text-box__container-detail"
        :class="titleBefore === false ? 'image-text-box__container-detail--reverse' : ''">
        <div class="image-text-box__title" v-html="title"></div>
        <div class="image-text-box__description" v-html="description"></div>
    </div>
</div>